import * as React from "react";
import { useMemo, useState } from "react";
import IndexRetentionContext from "./IndexRetentionContext";
const IndexRetentionProvider = ({ children }) => {
  const [maxNumberOfIndices, setMaxNumberOfIndices] = useState(void 0);
  const value = useMemo(
    () => ({ useMaxNumberOfIndices: [maxNumberOfIndices, setMaxNumberOfIndices] }),
    [maxNumberOfIndices]
  );
  return /* @__PURE__ */ React.createElement(IndexRetentionContext.Provider, { value }, children);
};
export default IndexRetentionProvider;
